import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from "recharts";

const PIE_COLORS = [
  "#e74c3c", "#3498db", "#2ecc71", "#f39c12", "#9b59b6",
  "#1abc9c", "#e67e22", "#34495e", "#e91e63", "#00bcd4",
];

export function PieChartCard(props: {
  title: string;
  data: any[];
  nameKey: string;
  valueKey: string;
}) {
  const data = Array.isArray(props.data) ? props.data : [];
  const hasData = data.length > 0;

  // Aggiungi colore a ogni slice per evitare grafico grigio
  const dataWithColors = data.map((item, i) => ({
    ...item,
    fill: PIE_COLORS[i % PIE_COLORS.length],
  }));

  return (
    <div className="card machines-section-card shadow-sm h-100">
      <div className="card-header fw-semibold">{props.title}</div>
      <div className="card-body" style={{ width: "100%", minHeight: 280, height: 320 }}>
        {hasData ? (
          <ResponsiveContainer width="100%" height={280} minHeight={200}>
          <PieChart>
            <Tooltip />
              <Pie
                data={dataWithColors}
                dataKey={props.valueKey}
                nameKey={props.nameKey}
                outerRadius={110}
              >
                {dataWithColors.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={PIE_COLORS[index % PIE_COLORS.length]} />
                ))}
              </Pie>
          </PieChart>
        </ResponsiveContainer>
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100 text-muted small">
            Nessun allarme attivo
          </div>
        )}
      </div>
    </div>
  );
}